<template>
  <div class="asc-advanced-custom-alerts-configuration--wrapper">
    <asc-container>
      <asc-header uppercase size="h3" value="Analytic Details"> </asc-header>
    </asc-container>
    <asc-divider />
    <asc-container class="alert-name-contaner">
      <div class="alertNameWrapper">
        <v-row>
          <v-col cols="3" class="right-border">
            <div class="text-label">Airline</div>
            <div class="text-style">{{ airline }}</div>
          </v-col>
          <v-col cols="3" class="right-border">
            <div class="text-label">Platform</div>
            <div class="text-style">{{ platform }}</div>
          </v-col>
          <v-col
            v-if="
              alertType === 'advanced-fullflight' ||
              alertType === 'advanced-dplf'
            "
            cols="3"
            class="right-border"
          >
            <div class="text-label">Data Type</div>
            <div class="text-style">{{ getDataType }}</div>
          </v-col>
          <v-col
            v-if="alertType === 'advanced-acmf'"
            cols="3"
            class="right-border"
          >
            <div class="text-label">Report Type</div>
            <div class="text-style">{{ reportType }}</div>
          </v-col>
          <v-col cols="3">
            <asc-tooltip
              :tooltip="createdBy"
              top
              :tooltip-length="getCreatorLength"
            >
              <div class="creator-text-label">Creator</div>
              <div class="creator-text-style">
                {{ createdBy }}
              </div>
            </asc-tooltip>
          </v-col>
        </v-row>
      </div>
    </asc-container>
    <asc-divider />
    <asc-container>
      <div class="analyticNameWrapper">
        <v-row no-gutters>
          <v-col cols="12">
            <asc-tooltip
              :tooltip="isDataBricksRunning ? tooltipMsg : ''"
              :tooltip-length="100"
              :left="true"
            >
              <asc-text-field-input
                v-model="alertName"
                label="Analytic Name"
                :max-length="nameMaxLength"
                :disabled="isDataBricksRunning"
                :counter="!isReadOnly"
                :readonly="isReadOnly"
                @blur="handleBlurAlertName"
              />
            </asc-tooltip>
          </v-col>
        </v-row>
      </div>
      <div class="analyticDescriptionWrapper">
        <v-row no-gutters>
          <v-col cols="12">
            <div>
              <asc-label
                value="Analytic Description"
                size="sm"
                class="labelColor"
              >
              </asc-label>
            </div>

            <div class="rich-text-style">
              <asc-tooltip
                :tooltip-length="100"
                :tooltip="isDataBricksRunning ? tooltipMsg : ''"
                attach=".rich-text-style"
                right
              >
                <asc-rich-text-input
                  :key="alertDescription"
                  :comment="alertDescription"
                  :can-edit="!isDataBricksRunning || !isReadOnly"
                  placeholder=""
                  hide-details
                  :disabled="isDataBricksRunning || isReadOnly"
                  @updated="handleBlurAlertDescription"
                />
              </asc-tooltip>
            </div>
          </v-col>
        </v-row>
      </div>
      <div class="configurations">
        <v-row no-gutters>
          <v-col>
            <div
              :class="[
                'configurationSelectorWrapper',
                alertType === 'acmf'
                  ? 'snapshotConfigurations'
                  : 'fullFlightConfigurations',
              ]"
            >
              <asc-tooltip
                :tooltip-length="100"
                :tooltip="isDataBricksRunning ? tooltipMsg : ''"
                :left="true"
              >
                <div class="severity-ata-wrapper">
                  <asc-autocomplete-selector
                    id="severity"
                    v-model="severityLevel"
                    class="severitySelector"
                    placeholder="Select a Severity Level"
                    label="Severity"
                    no-array
                    component-type="single"
                    :items="getSeverityLevels"
                    :sort-items="false"
                    :disabled="isDataBricksRunning"
                    :readonly="isReadOnly"
                  ></asc-autocomplete-selector>

                  <asc-autocomplete-selector
                    v-if="
                      alertType === 'advanced-fullflight' ||
                      alertType === 'advanced-acmf'
                    "
                    id="ataChapters"
                    v-model="ataChapters"
                    class="ataSelector"
                    label="ATA Chapter"
                    use-array
                    component-type="multiple"
                    :items="ataChapterList"
                    :display-error-message="isAtaErrorDisplayed"
                    placeholder="Select an ATA Chapter"
                    :disabled="isDataBricksRunning"
                    :readonly="isReadOnly"
                    validation-error-message="Please select an ATA Chapter."
                  ></asc-autocomplete-selector>
                </div>
              </asc-tooltip>
            </div>
          </v-col>
        </v-row>
      </div>
    </asc-container>
  </div>
</template>

<script>
import AscTextFieldInput from '../atoms/AscTextFieldInput.vue'
import AscTooltip from '@/components/atoms/AscTooltip'
import AscAutocompleteSelector from '../molecules/AscAutocompleteSelector.vue'
import AscHeader from '@/components/atoms/AscHeader'
import AscDivider from '../atoms/AscDivider.vue'
import AscContainer from '../atoms/AscContainer.vue'
import AscRichTextInput from '@/components/atoms/AscRichTextInput'
import AscLabel from '../atoms/AscLabel.vue'

export default {
  name: 'AscAdvancedCustomAlertsConfigurationWrapper',

  components: {
    AscTextFieldInput,
    AscAutocompleteSelector,
    AscHeader,
    AscDivider,
    AscContainer,
    AscRichTextInput,
    AscLabel,
    AscTooltip,
  },

  props: {
    tooltipMsg: {
      type: String,
      default: '',
    },
    isDataBricksRunning: {
      type: Boolean,
      default: false,
    },
    alertData: {
      type: Object,
      default: () => {},
    },
    alertType: {
      type: String,
      default: '',
    },
    airline: {
      type: String,
      default: '',
    },
    platform: {
      type: String,
      default: '',
    },
    reportType: {
      type: String,
      default: '',
    },
    parameterTailList: {
      type: Array,
      default: () => [],
    },
    ataChapterList: {
      type: Array,
      default: () => [],
    },
    airlineId: {
      type: Number,
      default: 0,
    },
    isAtaErrorDisplayed: {
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    alertName: {
      get() {
        return this.alertData?.name
      },
      set(value) {
        this.handleUpdateAlertName(value)
      },
    },
    alertDescription: {
      get() {
        return this.alertData?.analyticDescription
      },
      set(value) {
        this.handleUpdateAlertDescription(value)
      },
    },
    createdBy() {
      return this.alertData?.createdBy
    },
    getTails() {
      return this.parameterTailList
    },
    getSeverityLevels() {
      const itemArray = []
      itemArray.push({
        text: 'High Warning',
        value: 'highWarning',
      })
      itemArray.push({
        text: 'High Caution',
        value: 'highCaution',
      })
      itemArray.push({
        text: 'Low Caution',
        value: 'lowCaution',
      })
      itemArray.push({
        text: 'Low Warning',
        value: 'lowWarning',
      })
      return itemArray
    },
    tailIds: {
      get() {
        return this.alertData?.tails
      },
      set(val) {
        this.$emit('handleChangeTails', val)
      },
    },
    ataChapters: {
      get() {
        return this.alertData?.ataChapters
      },
      set(val) {
        if (val.length !== 0 || this.ataChapters.length !== 0) {
          this.isAtaErrorDisplayed = false
          this.$emit('isDirty')
          this.$emit('handleChangeAtaChapters', val)
        } else this.isAtaErrorDisplayed = true
      },
    },
    severityLevel: {
      get() {
        return this.alertData?.severityLevel
      },
      set(val) {
        this.$emit('isDirty')
        this.$emit('handleChangeSeverityLevel', val)
      },
    },
    nameMaxLength() {
      if (
        this.alertType === 'advanced-fullflight' ||
        this.alertType === 'advanced-acmf'
      ) {
        return 45
      }
      return 200
    },
    getDataType() {
      return this.alertType === 'advanced-fullflight'
        ? 'Full Flight'
        : 'Fault Code'
    },
    getCreatorLength() {
      return this.createdBy?.length
    },
  },

  methods: {
    handleUpdateAlertName(value) {
      this.$emit('isDirty')
      this.$emit('handleUpdateAlertName', value)
    },
    handleUpdateAlertDescription(value) {
      this.$emit('isDirty')
      this.$emit('onUpdateAlertDescription', value)
    },
    handleBlurAlertName(value) {
      if (!value) {
        value =
          this.alertType === 'acmf'
            ? 'ACMF Data Alert'
            : this.alertType === 'fullflight'
            ? 'Full Flight Data Alert'
            : this.alertType === 'advanced-fullflight'
            ? 'Advanced Logic Full Flight Data Alert'
            : this.alertType === 'advanced-dplf'
            ? 'Advanced Logic Fault Code Data Alert'
            : 'Advanced Logic ACMF Data Alert'
      }
      this.alertName = value
    },
    handleBlurAlertDescription(value) {
      this.alertDescription = value
    },
  },
}
</script>

<style lang="scss">
.asc-advanced-custom-alerts-configuration--wrapper {
  .asc-customAlerts-configuration--parameterNameTab {
    span {
      display: inline-block;
      padding-right: 10px;
    }

    .v-tab {
      max-width: initial;
    }
  }

  .alert-name-contaner {
    .asc-container--headerWrapper {
      padding: 10px 0 0 0;
    }
  }

  .alertNameWrapper {
    display: flex;
    align-items: center;

    .asc-input-field--container {
      flex: 3;
    }
  }

  .analyticDescriptionWrapper {
    margin-top: 10px;
    margin-bottom: 10px;

    .labelColor {
      color: $gray-700;
    }
    .editor__content .ProseMirror {
      padding: 10px 0;
    }

    .rich-text-style {
      max-height: 70px;
      overflow-y: scroll;
    }
  }

  .right-border {
    border-right: 1px solid $gray-200;

    .text-label {
      color: $gray-700 !important;
      line-height: 18px;
      font-size: 12px;
      height: 18px;
      left: 0 !important;
    }

    .text-style {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis !important;
    }
  }

  .creator-text-label {
    color: $gray-700 !important;
    line-height: 18px;
    font-size: 12px;
    height: 18px;
    left: 0 !important;
  }

  .creator-text-style {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis !important;
  }

  .asc-divider {
    border-color: $gray-200;
  }

  .configurations {
    .configurations--header {
      & .asc-header--h3 {
        letter-spacing: 0 !important;
      }
      margin-top: 15px;
    }

    .configurationSelectorWrapper {
      margin-bottom: 15px;

      .radioWrapper {
        margin-bottom: 20px;
      }

      .severity-ata-wrapper {
        display: flex;
        margin-top: 10px;
        margin-bottom: 10px;
        z-index: 1;
      }

      > div {
        margin-right: 20px;
      }

      .ataSelector {
        flex: none;
        margin-left: 20px;
      }

      .ataSelector,
      .severitySelector {
        flex: 1;
      }

      .asc-label {
        font-size: 12px;
        color: $gray-700;
      }

      .displayTitleInline {
        display: inline-flex;
        align-items: center;
      }
    }
  }
}
</style>
